module.exports = __webpack_public_path__ + "b12600c73daf85ea8f1c299cfa92d924.svg";